import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const ReadingIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.929 3.23942L7.54301 0.135577C7.4486 0.0490385 7.32115 0 7.18741 0H0.503497C0.225 0 0 0.20625 0 0.461538V12.4615C0 12.7168 0.225 12.9231 0.503497 12.9231H10.5734C10.8519 12.9231 11.0769 12.7168 11.0769 12.4615V3.56683C11.0769 3.44423 11.0234 3.32596 10.929 3.23942ZM9.91574 3.77885H6.95455V1.06442L9.91574 3.77885ZM9.94406 11.8846H1.13287V1.03846H5.88462V4.15385C5.88462 4.31451 5.95424 4.46859 6.07817 4.58219C6.2021 4.69579 6.37019 4.75962 6.54545 4.75962H9.94406V11.8846ZM5.41259 7.99038H2.51748C2.44825 7.99038 2.39161 8.04231 2.39161 8.10577V8.79808C2.39161 8.86154 2.44825 8.91346 2.51748 8.91346H5.41259C5.48182 8.91346 5.53846 8.86154 5.53846 8.79808V8.10577C5.53846 8.04231 5.48182 7.99038 5.41259 7.99038ZM2.39161 6.14423V6.83654C2.39161 6.9 2.44825 6.95192 2.51748 6.95192H8.55944C8.62867 6.95192 8.68532 6.9 8.68532 6.83654V6.14423C8.68532 6.08077 8.62867 6.02885 8.55944 6.02885H2.51748C2.44825 6.02885 2.39161 6.08077 2.39161 6.14423Z"
        fill="#111111"
      />
    </SvgIcon>
  );
};

export default ReadingIcon;
